import React, { useCallback } from 'react'
import styled from 'styled-components'
import Loader from 'react-loader-spinner'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import BaseButton from 'components/Button'
import Alert from 'components/Alert'
import useQueryParams from 'hooks/useQueryParams'
import { Input } from 'components/Input'
import { useInput } from 'hooks/useInput'
import { login } from 'features/user/actions'
import { isLoadingSelector, errorSelector } from 'features/user/selectors'
import CardScreen from 'screens/CardScreen'

const InputGroup = styled.div`
  display: block;
  margin-bottom: 1em;
`
const Label = styled.label`
  display: inline-block;
  font-weight: 600;
  margin-bottom: 6px;
  text-transform: uppercase;
`
const Button = styled(BaseButton)`
  display: block;
  margin: 28px auto 10px auto;

  svg {
    display: block;
    margin: auto;
  }
`

export default function Login() {
  const dispatch = useDispatch()
  const { value: username, onChange: onUsernameChange } = useInput('')
  const { value: password, onChange: onPasswordChange } = useInput('')
  const history = useHistory()
  const isLoading = useSelector(isLoadingSelector)
  const error = useSelector(errorSelector)
  const queryParams = useQueryParams()

  const loginCallbak = useCallback(() => {
    const next: string = queryParams.get('next') || '/'
    history.push(next)
  }, [queryParams, history])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    dispatch(login(username as string, password as string, loginCallbak))
  }

  return (
    <CardScreen title="Log In">
      <form onSubmit={handleSubmit}>
        <InputGroup>
          <Label>Username</Label>
          <Input
            type="text"
            placeholder="Username"
            value={username}
            onChange={onUsernameChange}
          />
        </InputGroup>

        <InputGroup>
          <Label>Password</Label>
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={onPasswordChange}
          />
        </InputGroup>

        {error && <Alert type="error">{error}</Alert>}

        <Button variant="main" disabled={isLoading}>
          {isLoading ? (
            <Loader type="TailSpin" width={20} height={20} />
          ) : (
            'Login'
          )}
        </Button>
      </form>
    </CardScreen>
  )
}
